document.addEventListener('DOMContentLoaded', function () {
  console.log('kensium');
  const addToCartButton = document.querySelector('.product-form__buttons .product-form__submit');
  document.addEventListener('click', (event) => {
    if (event.target.closest('.customAddtocart')) {console.log('dfdfs');
        if (confirmationModal.style.display === 'flex') {
                return;
            }
            confirmationModal.style.display = 'flex';
        }
  });
    confirmOk.addEventListener('click', () => {
      document.querySelector('.product-form__buttons .product-form__submit').click();
      confirmationModal.style.display = 'none';
    });
  confirmCancel.addEventListener('click', () => {
   confirmationModal.style.display = 'none';
});
});
// document.addEventListener('DOMContentLoaded', function () {
// /* add to cart button code */
//    const addToCartButton = document.querySelector('.product-form__buttons .product-form__submit');
//     // Get references to modal elements
//     const confirmationModal = document.getElementById('confirmationModal');
//     const confirmOk = document.getElementById('confirmOk');
//     const confirmCancel = document.getElementById('confirmCancel');
//     const showConfirmationPopup = document.getElementById('kensium-show-confirmation-popup').value;
//       //new
//     let formToSubmit = null;
//     let allowApiCall = false; // Flag to control API calls
//     document.addEventListener('click', (event) => {
//     if (event.target.closest('.product-form__submit')) {
//       if(showConfirmationPopup == 1){
//         event.preventDefault();
//         // Perform validation
//         let validationSuccess = validateForm();
    
//         if (validationSuccess) {
//             formToSubmit = document.querySelector('form[action="/cart/add"]');
//             if (confirmationModal.style.display === 'flex') {
//                 return; // Avoid reopening the modal if already displayed
//             }
//             confirmationModal.style.display = 'flex'; // Show the modal
//         }
//          window.fetch = ((originalFetch) => (...args) => {
//         if (args[0].includes('/cart/add.js') && !allowApiCall) {
//             return Promise.resolve(); // Block the API call
//         }
//         return originalFetch(...args);
//     })(window.fetch);
//       }
//     }
//     });
    
//     confirmOk.addEventListener('click', () => {
//         if (formToSubmit) {
//             allowApiCall = true; // Allow API call
//             formToSubmit.submit(); // Manually submit the form
//             allowApiCall = false; // Reset after submission
//         }
//         confirmationModal.style.display = 'none';
//     });
    
//     confirmCancel.addEventListener('click', () => {
//         confirmationModal.style.display = 'none';
//     });
    
//     function validateForm() {
//         let isValid = true;
//         const errorFields = [];
//         const requiredFields = document.querySelectorAll('[data-required="1"]:not([disabled])');
    
//         requiredFields.forEach((field) => {
//             if (!field.value.trim()) {
//                 isValid = false;
//             }
//         });    
//         return isValid;
//     }  
// });
